(ns shared.core.components.interactive
  (:require [shared.core.reactive :as re]))

(defn interactive []
  (let [hover-feature-disabled?- (re/subscribe [:core/feature-disabled?- :interactive/hover])
        hover-private?* (re/ratom false)
        focused-private?* (re/ratom false)
        pressed-private?* (re/ratom false)
        theme- (re/subscribe [:core/theme-])]
    (fn [comp
         {:keys [style disabled-style hover-style dark-hover-style pressed-style focus-style on-mouse-over on-mouse-out
                 on-focus on-blur on-mouse-down on-mouse-up hover-content pressed-content disabled hover?* focused?*
                 pressed?* keep-contents? on-pointer-down on-pointer-up]
          :as args}
         & contents]
      (let [hover?* (or hover?* hover-private?*)
            focused?* (or focused?* focused-private?*)
            pressed?* (or pressed?* pressed-private?*)
            enabled? (not disabled)
            s (cond-> style
                      disabled (merge disabled-style)
                      (and @hover?* enabled?) (merge hover-style)
                      (and @hover?* enabled? (= @theme- :dark)) (merge dark-hover-style)
                      (and @focused?* enabled?) (merge focus-style)
                      (and @pressed?* enabled?) (merge pressed-style))]
        (-> (if (vector? comp) comp [comp])
            (conj (-> args
                      (assoc :style s
                             :on-mouse-over (when-not @hover-feature-disabled?-
                                              #(do (reset! hover?* true)
                                                   (when on-mouse-over (on-mouse-over %))))
                             :on-mouse-out (when-not @hover-feature-disabled?-
                                             #(do (reset! hover?* false)
                                                  (reset! pressed?* false)
                                                  (when on-mouse-out (on-mouse-out %))))
                             :on-focus #(do (reset! focused?* true)
                                            (when on-focus (on-focus %)))
                             :on-blur #(do (reset! focused?* false)
                                           (when on-blur (on-blur %)))
                             :on-mouse-down #(do (reset! pressed?* true)
                                                 (when on-mouse-down (on-mouse-down %)))
                             :on-mouse-up #(do (reset! pressed?* false)
                                               (when on-mouse-up (on-mouse-up %)))
                             :on-pointer-down #(do (reset! pressed?* true)
                                                   (when on-pointer-down (on-pointer-down %)))
                             :on-pointer-up #(do (reset! pressed?* false)
                                                 (when on-pointer-up (on-pointer-up %))))
                      (dissoc :disabled-style :hover-style :dark-hover-style :pressed-style :focus-style
                              :hover-content :pressed-content :disabled :hover?* :focused?*
                              :pressed?* :keep-contents? :theme)))
            (into (cond
                    (and @pressed?* pressed-content) (if keep-contents?
                                                       (concat [pressed-content] [contents])
                                                       [pressed-content])
                    (and @hover?* hover-content) (if keep-contents?
                                                   (concat [hover-content] [contents])
                                                   [hover-content])
                    :else contents)))))))
